import { isMobile } from "react-device-detect"
import { imagenesAll } from "../asset/img"
import { BeforeFooterDekstop, BeforeFooterMobile, IsMobileHeader, IsPcHeader } from "../componentes/Principales"
import { CardPortafolioMedia } from "./Home"
import imgPrueba from '../asset/img/vector.png'
import { useEffect, useState } from "react"
import Card from "../componentes/Card360"
import styled from "styled-components";

//asset
import bgCardMarketingImg from'../asset/img/recursos/mobile/vServiciosMarketing.png'
import bgCardGrowth from'../asset/img/recursos/mobile/vServiciosGrowth.png'
import bgCardBranding from'../asset/img/recursos/mobile/vServiciosBrading.png'
import bgCardDesarrollo from'../asset/img/recursos/mobile/vServiciosDesarrolloMobile.png'
import bgCardEventos from'../asset/img/recursos/mobile/vServiciosEventos.png'

export const Servicios =()=>{
  return(
    <>
    {isMobile ? <ServiciosMobile /> : <ServiciosDesktop />}
    </>
  )
}

const ServiciosDesktop =()=>{
  const [isHover, setIsHover] = useState({
    card1: false,
    card2: false,
    card3: false,
    card4: false,
    card5: false,
  });
  const handleMouseEnter = (card) => {
    setIsHover((prevState) => ({ ...prevState, [card]: true }));
  };
  const handleMouseLeave = (card) => {
    setIsHover((prevState) => ({ ...prevState, [card]: false }));
  };
    useEffect(() => {
      document.title = "WAZ - servicios";
    }, []);
  return(
    <div className="w-100 d-flex flex-column align-items-center justify-content-start ma_servicePage_header">
      <IsPcHeader imgUrlWaz={imagenesAll.logoWazBordo} />
        <div className="m_w_80">
          <div className="w-100 my-3">
            <h4 className="m_hl m_text_secondary my-5 py-5 mx-5">Si fuésemos <span className="m_text_orange">tu hada madrina</span><br></br>estos serían nuestros poderes</h4>
          </div>
        </div>
        {/*nuestros servicios */}
        
        <section className="m_w_90 ">
          <p className="m_text_secondary w-100 text-center m_h3 m_hs ">Nuestros Servicios</p>

          <div className="d-flex flex-wrap flex-md-nowrap m-5 flex-column ">

{/*  Marketing  */}
          <div onMouseEnter={() => handleMouseEnter('card1')}
              onMouseLeave={() => handleMouseLeave('card1')} className="my-5 m_bg_f2f2f2 ma_ticky d-flex w-100">
            <div className="rounded-3 mx-3 d-flex justify-content-start w-100 ma-ServicioPageMarketing align-items-start justify-content-end flex-column ">
              <p className={`m_text_primary ms-3 m_hl ma_animacion_all2  m_bs m_fs_1`}><span className="fw-bold">MARKETING </span>DIGITAL</p>
              <p className={`m_text_primary m-3 m_bl fs-4 ${isHover.card1 ? 'ma_animacion_all2 ' : 'ma_animacion_all2 ma_oculto'}`}>Trabajamos de la mano con tu marca para definir objetivos claros, identificar audiencias clave y crear mensajes inolvidables.</p>

            </div>
            <div className="m_w_60 rounded-3"  style={{ flex: '0 0 60%' }}>
              <img className="w-100 rounded-3" src={imagenesAll.servicioCard1} alt="servicio 1" />
            </div>
          </div>

{/*  growth y pauta  */}
          <div onMouseEnter={() => handleMouseEnter('card2')}
              onMouseLeave={() => handleMouseLeave('card2')} className="my-5 m_bg_f2f2f2 ma_ticky d-flex w-100 my-3">
            <div className="m_w_60 rounded-3  mx-3"  style={{ flex: '0 0 60%' }}>
              <img className="w-100 rounded-3" src={imagenesAll.servicioCard2} alt="servicio 1" />
            </div>

            <div className="m_bg_pink rounded-3 mx-3 d-flex w-100 ma-ServicioPageGrowth align-items-start justify-content-end flex-column ">
              <p className={`m_text_primary ms-3 m_hl ma_animacion_all2 ma_animacion_all3 m_bs ${isHover.card2 ? 'fs-1' : 'm_fs_1'}`}><span className="fw-bold">GROWTH</span> Y PAUTA PUBLICITARIA</p>
               <p className={`m_text_secondary m-3 m_bl fs-4  ${isHover.card2 ? 'ma_animacion_all2 ' : 'ma_animacion_all2 ma_oculto'}`}>¡Movete más rápido que la competencia, que no te ganen! Diseñamos estrategias de pauta publicitaria personalizadas para maximizar la visibilidad, el impacto y los resultados.</p>
            </div>
            
          </div>
{/*  branding  */}
          <div onMouseEnter={() => handleMouseEnter('card3')}
              onMouseLeave={() => handleMouseLeave('card3')} className="my-5 m_bg_f2f2f2 ma_ticky d-flex w-100">
            <div className=" m_bg_secondary rounded-3 mx-3 d-flex justify-content-start w-100 ma-ServicioPageBranding align-items-start justify-content-end flex-column ">
              <p className={`m_text_primary ms-3 m_hl ma_animacion_all2  m_bs m_fs_1 `}><span className="fw-bold">BRANDING</span></p>
              <p className={`m_text_primary m-3 m_bl fs-4 ${isHover.card3 ? 'ma_animacion_all2 ' : 'ma_animacion_all2 ma_oculto'}`}>No solo hay que ser sino también parecer. En WAZ damos vida a tu marca con diseños visualmente impactantes. Creamos marcas desde cero y actualizamos las que necesitan una sacudida. </p>

            </div>
            <div className="m_w_60 rounded-3"  style={{ flex: '0 0 60%' }}>
              <img className="w-100 rounded-3" src={imagenesAll.servicioCard3} alt="servicio 1" />
            </div>
          </div>
{/*  Desarrollo  */}
          <div onMouseEnter={() => handleMouseEnter('card4')}
              onMouseLeave={() => handleMouseLeave('card4')}  className="my-5 m_bg_f2f2f2 ma_ticky d-flex w-100 my-3">
            <div className="m_w_60 rounded-3 mx-3"  style={{ flex: '0 0 60%' }}>
              <img className="w-100 rounded-3" src={imagenesAll.servicioCard4} alt="servicio 1" />
            </div>
            <div className="m_bg_amarillo  rounded-3 mx-3 d-flex w-100 ma-ServicioPageDesarrollo align-items-start justify-content-end flex-column ">
              <p  className={`m_text_secondary ms-3 m_hl ma_animacion_all2 ma_animacion_all3 m_bs ${isHover.card4 ? 'fs-1' : 'm_fs_1'}`}><span className="fw-bold">DESARROLLO</span> WEB</p>
               <p className={`m_text_secondary m-3 m_bl fs-4  ${isHover.card4 ? 'ma_animacion_all2 ' : 'ma_animacion_all2 ma_oculto'}`}>La casa tiene que estar en orden por eso nos centramos en crear sitios web excepcionales. Desde sitios informativos, e-commerce, hasta plataformas interactivas, construimos sitios web que den ganas de comprar tus servicios y/o productos</p>
            </div>        
          </div>
{/*  eventos  */}

          <div onMouseEnter={() => handleMouseEnter('card5')}
              onMouseLeave={() => handleMouseLeave('card5')} className="my-5 m_bg_f2f2f2 ma_ticky d-flex w-100">
            <div className=" m_bg_primary rounded-3 mx-3 d-flex justify-content-start w-100 ma_ServicioPageEventos align-items-start justify-content-end flex-column ">
              <p className={`m_text_secondary ms-3 m_hl ma_animacion_all2 ma_animacion_all3  m_bs m_fs_1`}><span className="fw-bold">EVENTOS</span></p>
               <p className={`m_text_secondary m-3 m_bl fs-4  ${isHover.card5 ? 'ma_animacion_all2 ' : 'ma_animacion_all2 ma_oculto'}`}>Creamos experiencias personalizadas que reflejan la esencia de tu marca, desde eventos exclusivos hasta actividades únicas para clientes o colaboradores.</p>
            </div>
            <div className="m_w_60 rounded-3"  style={{ flex: '0 0 60%' }}>
              <img className="w-100 rounded-3" src={imagenesAll.servicioCard5} alt="servicio 1" />
            </div>
          </div>
            </div>
        </section>
        
      
      <section className="container mt-5">
        <div className="row ms-1 d-flex justify-content-between">
          <div className="col-lg-5 ms-3">
          <div className="d-flex flex-column ">
                <div className=""><span className="m_bg_amarillo py-1 px-3 rounded-3">OUR WORK</span></div>
                <div className="text-start">
                  <p style={{ lineHeight: 1 }} className="m_tm fs-1 pt-3">Estar en el<br/>mundo digital<br></br>es solo el <br></br>primer paso</p>
                  <p className="m_bm fs-5 mt-4">Saber cómo destacar es lo que marca la diferencia.<br></br>Y eso es lo que hacemos en WAZ</p>
                </div>
              </div>
          </div>
          <div className="col-lg-6 d-flex flex-column me-3">
            <div className="w-100 d-flex justify-content-end align-items-end mt-4 pt-3" >
              <img className="m_w_60 ms-5 rounded-2" src={imagenesAll.wazServicioLast} alt="bg" />
            </div>
          </div>
        </div>
      </section>

      <div className="mt-5 pt-5 w-100">
        <BeforeFooterDekstop text1="¿Te gustaría confirmar" text2="si hacemos match?" textBtn="Contanos tu proyecto" />
      </div>
    </div>
  )
}
const ServiciosMobile =()=>{
  return(
    <div className="">
      <IsMobileHeader />
      <div className="m_dfc w-100 ma_nosotrosHeader">
        <div className="m_w_90 my-5 py-5">
          <p className="m_text_secondary m_hm my-5 py-5">Si fuésemos <span className="m_text_orange">tu hada madrina </span> estos serían nuestros poderes</p>
        </div>
      </div>
      <section>
        <div className="m_dfc flex-column">
          <CardService frontImg={bgCardMarketingImg} titleBold={"MARKETING "} title={"Digital"} text={`Trabajamos de la mano con tu marca para definir objetivos claros, identificar audiencias clave y crear mensajes innolvidables.`} frontColor="#f56763" backColor="#f56763" textColor="#F8D6FF"/>
          <CardService frontImg={bgCardGrowth} titleBold={"GROWTH "} title={"Y PAUTA PUBLICITARIA"} text={`¡Movete más rápido que la competencia, que no te ganen! Diseñamos estrategias de pauta publicitaria personalizadas para maximizar la visibilidad, el impacto y los resultados.`}frontColor="#EDA3FE" backColor="#EDA3FE" textColor="#F8D6FF"/>
          <CardService frontImg={bgCardBranding} titleBold={"BRANDING "} title={""} text={`No solo hay que ser sino también parecer. En WAZ damos vida a tu marca con diseños visualmente impactantes. Creamos marcas desde cero y actualizamos las que necesitan una sacudida.`} frontColor="#5D276B" backColor="#5D276B" textColor="#F8D6FF"/>
          <CardService frontImg={bgCardDesarrollo} titleBold={"DESARROLLO "} title={"WEB"} text={`La casa tiene que estar en orden por eso nos centramos en crear sitios web excepcionales. Desde sitios informativos, e-commerce, hasta plataformas interactivas, construimos sitios web que den ganas de comprar tus servicios y/o productos.`} frontColor="#Daf559" backColor="#Daf559" textColor="#5D276B"/>
          <CardService frontImg={bgCardEventos} titleBold={"EVENTOS "} title={""} text={`Creamos experiencias personalizadas que reflejan la esencia de tu marca, desde eventos exclusivos hasta actividades únicas para clientes o colaboradores.`} frontColor="#F8D6FF" backColor="#F8D6FF" textColor="#5D276B"/>
        </div>
      </section>

      <div className="1-100 m_dfc flex-column mt-5 pt-5">
        <div className="m_w_90">
          <div className=""><span className="m_text_secondary m_bg_amarillo px-1 px-2 rounded-2">OUR WORK</span></div>
          <p className="m_hl">Estar en el mundo digital es solo el primer paso</p>
          <p className="m_tl m_text_black-grey">Saber cómo destacar es lo que marca la diferencia. Y eso es lo que hacemos en WAZ</p>
        </div>
        <div className="m_w_90">
        <div className="m_ctn_extended_proyecto1_home_mobile mb-5 pb-5 d-flex">
          <img className="w-100 rounded-2" src={imagenesAll.wazServicioLast} alt="bg" />
        <div className="me-2 d-none">
          <div className="m_bg_gradiant_portafolio rounded-3" style={{ height: "400px", width:"600px" }}>
            <div className=" pt-4">
              <span className="m_text_white m_tl">Social Media</span>
              <div className="d-flex">
                <CardPortafolioMedia
                  imgSocialMedia={imagenesAll.imgPortafolioLg1} 
                  altImgSocialMedia={"Digitalizate"} 
                  titleCard={"Lorem Ipsun"}
                  textCard={"Lorem ipsum dolor sit amet."}
                />
                <CardPortafolioMedia 
                  imgSocialMedia={imagenesAll.imgPortafolioLg2} 
                  altImgSocialMedia={"Digitalizate"} 
                  titleCard={"Lorem Ipsun"}
                  textCard={"Lorem ipsum dolor sit amet."}
                />
                <CardPortafolioMedia 
                  imgSocialMedia={imagenesAll.imgPortafolioLg3} 
                  altImgSocialMedia={"Digitalizate"} 
                  titleCard={"Lorem Ipsun"}
                  textCard={"Lorem ipsum dolor sit amet."}
                />
              </div>
            </div>
          </div>
          <div className="mt-2">
            <p className="m_text_secondary">2024 • MERCURIO SOFT</p>
            <p className="m_hm">Comunicación en<br></br>Linkedin</p>
            <p className="m_bs fs-3">Conectando con la<br></br> audiencia profesional.</p>
          </div>
        </div>

        <div className="ms-2 d-none" >
          <div className="d-flex align-items-center justify-content-around rounded-3" style={{  height: "400px", width:"600px", backgroundColor: '#090E2C'}}>
            <img className="rounded-2 w-25" src={imagenesAll.imgPortafolioLg23} alt="Portafolio" />
            <img className="m_w_30" src={imagenesAll.imgPortafolioLg21} alt="Portafolio" />
            <img className="rounded-2 w-25" src={imagenesAll.imgPortafolioLg22} alt="Portafolio" />
          </div>
          <div className="mt-2">
            <p className="m_text_secondary">2024 • MERCOSURIO SOFT</p>
            <p className="m_hm">Diseño Web<br></br>Institucional</p>
            <p className="m_bs fs-3">Transformando la<br></br> presencia en línea.</p>
          </div>
        </div>

        </div>
        </div>
      </div>
      <BeforeFooterMobile text1="¿Te gustaría" text2="confirmar si" text3="hacemos match?" textBtn="Contanos tu proyecto." />
    </div>
  )
}



const cardsData = [
  {
    text1: "MARKETING",
    text2: "DIGITAL",
    img: imagenesAll.servicioCard1,
  },
  {
    text1: "GROWTH",
    text2: "Y PAUTA PUBLICITARIA",
    img: imagenesAll.servicioCard2,
  },
  {
    text1: "BRANDING",
    text2: "",
    img: imagenesAll.servicioCard3,
  },
  {
    text1: "DESARROLLO",
    text2: "WEB",
    img: imagenesAll.servicioCard4,
  },
  {
    text1: "EVENTOS",
    text2: "",
    img: imagenesAll.servicioCard5,
  },
];

const ServiciosCards = () => {
  return (
    <div>
      {cardsData.map((card, index) => (
        <RectanguloDividido
          key={index}
          invertido={index % 2 === 1}
          imagen={card.img}
          texto={{ text1: card.text1, text2: card.text2 }}
        />
      ))}
    </div>
  );
};
const RectanguloDividido = ({ imagen, texto, invertido }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: invertido ? "row-reverse" : "row",
        width: "100%",
        height: "300px",
        margin: "3rem", // equivalente a m-5
        flexWrap: "wrap",
        gap: "1rem",
      }}
    >
      <div
        style={{
          flex: "3",
          backgroundColor: "#090E2C",
          color: "white",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "2rem",
          textAlign: "center",
          padding: "1rem",
          borderRadius: "1rem", // rounded-3
        }}
      >
        <span>
          <span className="fw-bold">{texto.text1}</span> {texto.text2}
        </span>
      </div>
      <div style={{ flex: "7" }}>
        <img
          src={imagen}
          alt="servicio"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: "1rem", // rounded-3
          }}
        />
      </div>
    </div>
  );
};

const CardService = ({ titleBold, title, text, frontColor, backColor, textColor, frontImg }) => {
  const [flipped, setFlipped] = useState(false);

  return (
    <StyledWrapper 
      frontColor={frontColor} 
      backColor={backColor} 
      textColor={textColor}
      frontImg={frontImg}
    >
      <div 
        className={`card my-1 ${flipped ? "flipped" : ""}`} 
        onClick={() => setFlipped(!flipped)}
      >
        <div className="card-inner">
          <div className="card-front">
            <p className="fs-1 m_tl"><strong>{titleBold}</strong>{title}</p>
          </div>
          <div className="card-back">
            <p className="m_bs">{text}</p>
          </div>
        </div>
      </div>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  .card {
    width: 300px;
    height: 200px;
    perspective: 1000px;
  }

  .card-inner {
    width: 100%;
    height: 100%;
    position: relative;
    transform-style: preserve-3d;
    transition: transform 0.6s;
  }

  .card.flipped .card-inner {
    transform: rotateY(180deg);
  }

  .card-front,
  .card-back {
    position: absolute;
    width: 100%;
    height: 100%;
    backface-visibility: hidden;
    border-radius: 5px;
    display: flex;
    align-items: end;
    justify-content: start;
    font-size: 20px;
    color: ${({ textColor }) => textColor || "#fff"};
    padding: 1rem;
    text-align: start;
    word-wrap: break-word;
  }

  .card-front {
    background-color: ${({ frontColor }) => frontColor || "#f56763"};
    background-image: ${({ frontImg }) => frontImg ? `url(${frontImg})` : "none"};
    background-size: auto 100%;
    background-repeat: no-repeat;
    background-position: left top;
    border: 0 solid ${({ frontColor }) => frontColor || "#f56763"};
    transform: rotateY(0deg);
  }

  .card-back {
    background-color: ${({ backColor }) => backColor || "#F08A5D"};
    border: 10px solid ${({ backColor }) => backColor || "#F08A5D"};
    transform: rotateY(180deg);
  }
`;
